export const log = (error: Error | unknown) => {
  // eslint-disable-next-line no-console
  console.log(`${new Date().toISOString()}: ${error}`);
};
